<template>
  <div @click.stop="handleFavorite">
    <div class="relative flex items-center">
      <OIcon
        :icon="`article/${isActive ? 'kesfet-favorite-checked' : 'kesfet-favorite-nonchecked'}`"
        class="w-6 h-6 u-center cursor-pointer mr-1"
        :aria-label="isActive ? $t('main.remove-favorites') : $t('main.add-favorites')"
      />
      <p class="hover:cursor-pointer text-primary-300" :class="isActive && 'text-[#306AFF]'">
        {{ isActive ? 'Kaydedildi' : 'Kaydet' }}
      </p>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, useContext, inject, computed } from '@nuxtjs/composition-api';
import { sendReactionCommentLayer } from '@/modules/tracking/scripts/dataLayer';
import { useDialog, useModal, useNotify } from '~/composables/useModal';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import OIcon from '~/modules/common/components/ui/OIcon/OIcon.vue';
import { PROFILE_PATH, FAVORITE_PATH } from '~/constants/config';

export default defineComponent({
  components: {
    OIcon,
  },

  setup() {
    const article = inject('article');
    const name = inject('dataLayerName')?.value;
    const { $service } = useContext();
    const { isMobile } = useDevice();
    const { openLoginModal } = useModal();
    const { openErrorDialog } = useDialog();
    const { notifySuccess } = useNotify();
    const { isLoggedIn, user } = useAuth();
    const isActive = ref(article.isFavorite);

    const articleCount = computed(() => user.value.stats?.articles);

    if (!isLoggedIn.value) {
      isActive.value = false;
    }

    const handleFavorite = async () => {
      if (!isLoggedIn.value) {
        await openLoginModal();
        return;
      }
      try {
        if (!isActive.value) {
          await $service.article.favoriteArticle(article._id);
          isActive.value = true;
          sendReactionCommentLayer('Bookmark', { article }, null, name, 'Keşfet');
          notifySuccess('İçerik kaydedildi.', {
            actionName: 'Okuma Listemi Görüntüle',
            actionUrl: `/${PROFILE_PATH}/${user.value.username}${articleCount.value > 0 ? '/' + FAVORITE_PATH : ''}`,
          });
        } else {
          await $service.article.unfavoriteArticle(article._id);
          isActive.value = false;
        }
      } catch (error) {
        openErrorDialog({ error });
        isActive.value = false;
      }
    };
    return {
      isActive,
      isMobile,
      handleFavorite,
      PROFILE_PATH,
      FAVORITE_PATH,
      articleCount,
      user,
    };
  },
});
</script>

<style></style>
